import styled from "styled-components";

export const ChangePasswordContainer = styled.div`
  h2 {
    margin-bottom: 0px !important;
    color: #414651;
    font-size: 14px;
    font-weight: 500;
    font-family: "Geist", sans-serif;
  }
  span {
    color: #535862;
    font-size: 14px;
    font-weight: 400;
    font-family: "Geist", sans-serif;
  }

  .form-control.input-form-field {
    border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    background: ${({ theme }) => theme.toast.bg.primary} !important;
  }

  .security-password-input {
    input {
      margin-bottom: 30px;
    }

    form .row {
      height: 7rem;
    }
  }
  .divider {
    border-top: 1px solid ${({ theme }) => theme.menu.divider};
  }

  .password-heading-container {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-bottom: 25px;
  }
  .password-button-wrapper {
    flex: 1;
  }
  .password-heading-wrapper {
    flex: 1;
  }

  .form {
    .security-password-input {
      label {
        margin-bottom: 7px;
      }
    }
  }

  button.button-small {
    &:disabled {
      border: 1px solid ${({ theme }) => theme.aside.icon.tertiary};
    }
  }

  .password-success-modal {
    .modal-dialog {
      margin-top: 100px;
      .modal-content {
        width: 392px !important;
        .logo-img {
          .img {
            height: 110px;
            width: 110px;
          }
        }
        .modal-body {
          div {
            .heading-space {
              .heading {
                font-weight: 700;
                font-size: 23px !important;
              }
            }
          }
        }
      }
    }
  }

  .two-factor-auth {
    margin: 4rem 0;
  }

  @media (max-width: 768px) {
    .password-heading-container {
      flex-direction: column;
    }

    .password-button-wrapper {
      flex: auto;
      width: 100%;
    }
    .button-small {
      width: 100%;
    }
  }
`;
